import React from 'react';
import { PaginationWrapper, PageButton, PageSelectWrapper, PageSelect, SelectArrow, EllipsisSpan } from './styles';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  recordsPerPage: number;
  onPageChange: (page: number) => void;
  onLimitChange: (limit: number) => void;
}

const PaginationControls: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  totalItems,
  recordsPerPage,
  onPageChange,
  onLimitChange,
}) => {
  const pageLimits = [20, 50, 70, 100];

  const getPaginationButtons = () => {
    const buttons: (number | string)[] = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) {
        buttons.push(i);
      }
    } else {
      if (currentPage <= 4) {
        buttons.push(1, 2, 3, 4, 5, '...', totalPages);
      } else if (currentPage > totalPages - 4) {
        buttons.push(1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        buttons.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
      }
    }
    return buttons;
  };

  return (
    <PaginationWrapper>
      <PageButton disabled={currentPage === 1} onClick={() => onPageChange(currentPage - 1)}>
        &lt;
      </PageButton>

      {getPaginationButtons().map((page, index) =>
        typeof page === 'string' ? (
          <EllipsisSpan key={index}>{page}</EllipsisSpan>
        ) : (
          <PageButton key={index} active={page === currentPage} onClick={() => onPageChange(page)}>
            {page}
          </PageButton>
        )
      )}

      <PageButton disabled={currentPage === totalPages} onClick={() => onPageChange(currentPage + 1)}>
        &gt;
      </PageButton>

      <PageSelectWrapper>
        <PageSelect value={recordsPerPage} onChange={(e) => onLimitChange(Number(e.target.value))}>
          {pageLimits.map((limit) => (
            <option key={limit} value={limit}>
              {limit}
            </option>
          ))}
        </PageSelect>
        <SelectArrow />
      </PageSelectWrapper>
    </PaginationWrapper>
  );
};

export default PaginationControls;
